import React, { useState } from "react";
import Wifi from "@material-ui/icons/Wifi";

import loadContent from "core-module/hoc/loadContent";
import MultiItemFormEdit from "../../common/components/MultiComponentForm/MultiItemFormEdit";
import MultiItemFormSummary from "../../common/components/MultiComponentForm/MultiItemFormSummary";

function NewWiFiSettings(props) {
  const [dialogOpen, setDialogOpen] = useState(false);

  function openDialog() {
    setDialogOpen(true);
  }

  function closeDialog() {
    setDialogOpen(false);
  }

  const multiListItemProps = [
    { propName: "contactid", disabled: true },
    { propName: "wifi_enabled" },
    { propName: "wifi_ssid", passThroughProp: { type: "text" } },
    { propName: "wifi_password", passThroughProp: { type: "password" } },
    { propName: "guest_enabled" },
    { propName: "guest_ssid", passThroughProp: { type: "text" } },
    { propName: "guest_password", passThroughProp: { type: "password" } },
  ];
  return (
    <>
      <MultiItemFormEdit
        pathids={props}
        pathname="wifisettings"
        title="Edit Wi-Fi Settings"
        myProps={multiListItemProps}
        closeDialog={closeDialog}
        dialogOpen={dialogOpen}
      />
      <MultiItemFormSummary
        pathids={props}
        pathname="wifisettings"
        title="Wi-Fi Settings"
        myProps={multiListItemProps}
        openDialog={openDialog}
        icon={Wifi}
      />
    </>
  );
}

export default loadContent("user.session/wifisettings.props", NewWiFiSettings);
